/*
 * Copyright Deskshare Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

/**
 * The delivered session number this build was made from (FCR S732).
 *
 * The deploy build passes the repository's SESSION file as
 * VITE_DESKSHARE_SESSION, so a feature or test host can say which session is
 * live -- the back end reports the same number on /health/ as "session".
 * Read here and nowhere else. `undefined` when the build was not stamped.
 */
export function deliveredSession(
  raw: unknown = import.meta.env.VITE_DESKSHARE_SESSION,
): string | undefined {
  const value = typeof raw === "string" ? raw.trim() : "";
  return value === "" ? undefined : value;
}
